<template>
  <div class="stakeholder-responses">
    <BaseChart height="300px" chart-height="200px" dark title="Stakeholder Feedback" :chart-data="mergedChartData">
      <template #widget-options>
        <slot name="widget-options"></slot>
      </template>
    </BaseChart>
  </div>
</template>

<script>
import { commonPropertiesMixin } from './common-properties-mixin'

const customChartData = {
  title: {
    verticalAlign: 'middle',
    floating: true,
    y: 15,
    style: {
      color: 'white',
      textAlign: 'center'
    },
    useHTML: true
  },

  chart: {
    backgroundColor: 'var(--r-graph-8)'
  },

  plotOptions: {
    pie: {
      allowPointSelect: false,
      cursor: 'pointer',
      innerSize: '80%',
      align: 'center',
      borderColor: 'transparent',
      colors: ['var(--r-graph-11)', 'var(--r-graph-13)', 'var(--r-graph-likely)', 'var(--r-graph-10)'],
      center: ['50%'],
      size: '100%',
      crop: false,
      overflow: 'auto'
    },
    series: {
      dataLabels: {
        crop: false,
        padding: 0,
        color: 'white',
        style: {
          textOutline: false,
          textAlign: 'center',
          fontSize: '10px',
          fontWeight: 300
        },
        useHTML: true,
        enabled: true,
        format: `{point.y} <br/>{point.name}`
      }
    }
  }
}

export default {
  mixins: [commonPropertiesMixin('stakeholder-responses-single-period', customChartData)],

  watch: {
    chartData(val) {
      val && this.generateTitle()
    }
  },

  methods: {
    generateTitle() {
      const text = this.supportData.stakeholders_count
      const html = `
        <div class="chart-title">
          <span class="count">${text}</span>
          <span class="text">Stakeholders</span>
        </div>
      `
      this.$set(this.customChartData.title, 'text', html)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables.styl'

>>> .chart-title {
  display grid

  .count {
    font-size 1.5rem
    font-weight 400
  }

  .text {
    font-size 0.75rem
    font-weight 300
  }
}
</style>
